<div class="auth-wrapper">
  <div class="auth-card">

    <!-- Header -->
    <h2 class="title">Forgot Password</h2>
    <p class="subtitle">
      Enter your email and we’ll send you a reset link
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()">

      <div class="form-group">
        <label>Username</label>
        <input type="email" class="form-input" placeholder="you@example.com" formControlName="username" />
        <!-- Required error -->
        @if (form.controls['username'].touched &&
        form.controls['username'].errors?.['required']) {
        <div class="text-danger">
          Email is mandatory
        </div>
        }

        @if (form.controls['username'].touched &&
        form.controls['username'].errors?.['pattern']) {
        <div class="error-text">
          Enter a valid email address
        </div>
        }
      </div>

      <div class="success" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <div class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button class="primary-btn" type="submit" [disabled]="loading || form.invalid">
        {{ loading ? 'Submitting...' : 'Send Reset Link' }}
      </button>

      <div class="back-link">
        <a routerLink="/login">← Back to Login</a>
      </div>

    </form>
  </div>
</div>